import {ApiClient} from '@hconnect/apiclient'
import {useMutation, type UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {CreateUpdateScheduleItem, UpdateScheduleItemResponse} from '../api'

type Variables = {
  plantCode: string
  scheduleId: number
  scheduleItemDTO: CreateUpdateScheduleItem
  scheduleItemId: string
}

export const useUpdateScheduleItemMutation = (
  options?: Omit<
    UseMutationOptions<UpdateScheduleItemResponse, AxiosError, Variables>,
    'mutationFn'
  >
) =>
  useMutation<UpdateScheduleItemResponse, AxiosError, Variables>({
    ...options,
    mutationFn: async ({scheduleId, plantCode, scheduleItemDTO, scheduleItemId}) => {
      const response = await ApiClient.axiosInstance.put<UpdateScheduleItemResponse>(
        `/schedules/${scheduleId}/items/${scheduleItemId}`,
        scheduleItemDTO,
        {params: {plantCode}}
      )
      return response.data
    }
  })
